__turbopack_context__.v({
  "directoryBackdropFade": "directory-mobile-module-scss-module__IEKOsW__directoryBackdropFade",
  "directoryBlinkTwice": "directory-mobile-module-scss-module__IEKOsW__directoryBlinkTwice",
  "modal": "directory-mobile-module-scss-module__IEKOsW__modal",
  "modalBackdrop": "directory-mobile-module-scss-module__IEKOsW__modalBackdrop",
  "modalClose": "directory-mobile-module-scss-module__IEKOsW__modalClose",
  "modalHeader": "directory-mobile-module-scss-module__IEKOsW__modalHeader",
  "modalIcon": "directory-mobile-module-scss-module__IEKOsW__modalIcon",
  "modalItem": "directory-mobile-module-scss-module__IEKOsW__modalItem",
  "modalItemIcon": "directory-mobile-module-scss-module__IEKOsW__modalItemIcon",
  "modalList": "directory-mobile-module-scss-module__IEKOsW__modalList",
  "modalTitle": "directory-mobile-module-scss-module__IEKOsW__modalTitle",
});
